import { Link } from "react-router-dom";
import { hotTopics } from "@/mocks/topics";
import TopicCard from "@/components/feature/TopicCard";

export default function HotTopicsSection() {
  const list = [...hotTopics].sort((a, b) => b.heat - a.heat).slice(0, 6);

  return (
    <section id="hot" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs font-bold tracking-[0.25em] text-primary-600">
              HOT TOPICS
            </span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              热门大瓜推荐
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              按讨论热度挑选的本周大瓜，每条都附时间线与背景梳理，点开就能快速跟上进度。
            </p>
          </div>
          <Link
            to="/rank"
            className="flex items-center gap-1 whitespace-nowrap font-label text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            全部话题
            <i className="ri-arrow-right-line h-4 w-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((topic, index) => (
            <TopicCard key={topic.id} topic={topic} rank={index + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}